export default "/images/vendor/flag-icon-css/flags/1x1/mh.svg?f4334b2e5d62cd297935ae3e94cf28e2";